import { Layers } from "lucide-react";
import type { MapStyleDependencyPanelProps } from "../../contracts/map-styles";
import { cn } from "../../lib/utils";
import { MapAssetStatList } from "../map-assets/MapAssetStatList";
import { MapStyleDependencySummary } from "./MapStyleDependencySummary";

/**
 * A panel focused on map style dependencies (sources, sprites, glyphs).
 */
export function MapStyleDependencyPanel({
  title = "Style Dependencies",
  description,
  dependencies,
  summaryItems = [],
  emptyMessage,
  className,
}: MapStyleDependencyPanelProps) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Layers className="h-4 w-4 text-muted-foreground" />
          <h3 className="text-xs font-black uppercase tracking-wider text-foreground">
            {title}
          </h3>
        </div>
        {description && (
          <p className="text-[10px] text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>

      {summaryItems && summaryItems.length > 0 && (
        <div className="p-3 rounded-lg bg-background border border-border/50">
          <MapAssetStatList items={summaryItems} />
        </div>
      )}

      <div className="flex flex-col gap-2 p-3 rounded-lg border border-border bg-muted/5">
        <MapStyleDependencySummary 
          dependencies={dependencies} 
          emptyMessage={emptyMessage}
        />
      </div>
    </div>
  );
}
